import React, {useEffect, useMemo, useState} from 'react';
import {DatePickerCustom, InputEntidad, InputFormat, InputLista, Accordion, FormError, FormLabel} from '../../../../components/common';
import {getDateNow} from '../../../../utils/convert';
import InputNumber from '../../../../components/common/InputNumber';
import DataTaggerFormRedux from '../../../../components/controls/DataTaggerFormRedux';
import DomiciliosGrid from '../../../../components/controls/DomiciliosGrid';
import VinculosVehiculoGrid from '../../../../components/controls/VinculosVehiculoGrid';
import { ALERT_TYPE, CUENTA_STATE, MASK_FORMAT, OPERATION_MODE, PATTERNS, ShowToastMessage } from '@laramie/ui';
import {TabsForm} from './components';
import {MakeListDomicilios} from '../../utils';
import InputSecret from '../../../../components/common/InputSecret';
import {usePermissions} from '../../../../components/hooks/usePermissions';
import {PERMISSIONS} from '../../../../consts/permissions';
import {TIPS} from "../../../../consts/tips";

const SectionForm = ({
                         SetTabActive,
                         handleChangeInciso,
                         pendingChange,
                         setPendingChange,
                         state,
                         vehiculo_formValues,
                         vehiculo_formSet,
                         vehiculo_formHandleProxy,
                         cuenta_formValues,
                         cuenta_formSet,
                         cuenta_formHandleProxy,
                         UpdateEntity,
                         handleClickBaja,
                         refetchVehiculo,
                         errorOf,
                         datosOpen,
                         setDatosOpen,
                         administrativosOpen,
                         setAdministrativosOpen,
                         estadoOpen,
                         setEstadoOpen
                     }) => {

    const [domicilios, setDomicilios] = useState([]);

    const today = useMemo(() => getDateNow(), []);

    const {hasPermission} = usePermissions();
    const canEditPersonasVinculadas = hasPermission(PERMISSIONS.PERSONAS_VINCULADAS_EDIT);

    useEffect(() => {
        if (state.entity.zonasEntrega.length > 0 || state.entity.vinculosVehiculo.length > 0) {
            MakeListDomicilios(state)
                .then(response => {
                    setDomicilios(response);
                })
                .catch(error => {
                    const message = error.message;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                    setDomicilios([]);
                });
        } else {
            if (domicilios.length > 0) setDomicilios([]);
        }
    }, [state.entity.zonasEntrega, state.entity.vinculosVehiculo])

    return (
        <>
            <section className='section-accordion'>

                <div className="m-top-20 m-bottom-20">
                    <Accordion title="Cuenta" startOpen={true}>
                        <div className='row form-basic'>
                            <div className="col-12 col-md-3 col-lg-2">
                                <label htmlFor="cuenta_numeroCuenta" className="form-label">Número de cuenta</label>
                                <InputFormat
                                    name="cuenta_numeroCuenta"
                                    className="form-control"
                                    mask={MASK_FORMAT.CUENTA}
                                    maskPlaceholder={null}
                                    value={cuenta_formValues.numeroCuenta}
                                    onChange={cuenta_formHandleProxy}
                                    disabled={true}
                                />
                            </div>
                            <div className="col-6 col-md-4 col-lg-2">
                                <label htmlFor="cuenta_numeroWeb" className="form-label">Clave web</label>
                                <InputSecret
                                    name="cuenta_numeroWeb"
                                    mask={MASK_FORMAT.CLAVE_WEB}
                                    maskPlaceholder={null}
                                    value={cuenta_formValues.numeroWeb}
                                    onChange={cuenta_formHandleProxy}
                                    disabled={state.mode === OPERATION_MODE.VIEW}
                                />
                            </div>
                            {(state.mode === OPERATION_MODE.NEW) && <>
                                <div className="col-12 col-sm-4 col-lg-8">
                                    <FormLabel htmlFor="vehiculo_idIncisoVehiculo" required>Inciso</FormLabel>
                                    <InputEntidad
                                        name="vehiculo_idIncisoVehiculo"
                                        placeholder=""
                                        className={`form-control ${errorOf('idIncisoVehiculo') ? 'is-invalid' : ''}`}
                                        value={vehiculo_formValues.idIncisoVehiculo}
                                        onChange={handleChangeInciso}
                                        disabled={state.mode === OPERATION_MODE.VIEW}
                                        title="Inciso vehículo"
                                        entidad="IncisoVehiculo"
                                    />
                                    <FormError message={errorOf('idIncisoVehiculo')} />
                                </div>
                                <div className="col-12 col-sm-6 col-lg-4">
                                    <FormLabel htmlFor="vehiculo_idTipoVehiculo" required>Tipo</FormLabel>
                                    <InputEntidad
                                        name="vehiculo_idTipoVehiculo"
                                        placeholder=""
                                        className={`form-control ${errorOf('idTipoVehiculo') ? 'is-invalid' : ''}`}
                                        value={vehiculo_formValues.idTipoVehiculo}
                                        onChange={({target}) => {
                                            vehiculo_formSet({
                                                ...vehiculo_formValues,
                                                idTipoVehiculo: target.value
                                            });
                                            setPendingChange(true);
                                        }}
                                        disabled={state.mode === OPERATION_MODE.VIEW}
                                        title="Tipo vehículo"
                                        entidad="TipoVehiculo"
                                        filter={(row) => row.idIncisoVehiculo === vehiculo_formValues.idIncisoVehiculo}
                                    />
                                    <FormError message={errorOf('idTipoVehiculo')} />
                                </div>
                                <div className="col-12 col-sm-4 col-lg-4">
                                    <FormLabel htmlFor="vehiculo_anioModelo" required>Año/Modelo</FormLabel>
                                    <input
                                        name="vehiculo_anioModelo"
                                        type="text"
                                        placeholder=""
                                        className={`form-control ${errorOf('anioModelo') ? 'is-invalid' : ''}`}
                                        value={vehiculo_formValues.anioModelo}
                                        onChange={({target}) => {
                                            if (target.validity.valid) {
                                                vehiculo_formSet({
                                                    ...vehiculo_formValues,
                                                    anioModelo: target.value
                                                });
                                                setPendingChange(true);
                                            }
                                        }}
                                        disabled={state.mode === OPERATION_MODE.VIEW || vehiculo_formValues.idTipoVehiculo === ''}
                                        pattern={PATTERNS.onlyNumbers}
                                        maxLength={4}
                                    />
                                    <FormError message={errorOf('anioModelo')} />
                                </div>
                                <div className="col-12 col-sm-4 col-lg-4">
                                    <FormLabel htmlFor="vehiculo_dominio" required>Dominio</FormLabel>
                                    <input
                                        name="vehiculo_dominio"
                                        type="text"
                                        placeholder=""
                                        className={`form-control ${errorOf('dominio') ? 'is-invalid' : ''}`}
                                        value={vehiculo_formValues.dominio}
                                        onChange={({target}) => {
                                            if (target.validity.valid && target.value.length <= 7) {
                                                vehiculo_formSet({
                                                    ...vehiculo_formValues,
                                                    dominio: target.value.toUpperCase()
                                                });
                                                cuenta_formSet({
                                                    ...cuenta_formValues,
                                                    numeroCuenta: target.value.toUpperCase()
                                                });
                                                setPendingChange(true);
                                            }
                                        }}
                                        disabled={state.mode === OPERATION_MODE.VIEW}
                                        autoComplete="off"
                                        pattern={PATTERNS.onlyNumbersAndLetters}
                                    />
                                    <FormError message={errorOf('dominio')} />
                                </div>
                            </>}
                            {(state.mode !== OPERATION_MODE.NEW) && (
                                <>
                                    <div className="col-6 col-md-4 col-lg-2">
                                        <label htmlFor="cuenta_idEstadoCuenta" className="form-label">Estado de
                                            cuenta</label>
                                        <InputLista
                                            name="cuenta_idEstadoCuenta"
                                            placeholder=""
                                            className="form-control"
                                            value={state.entity.cuenta.idEstadoCuenta}
                                            disabled={true}
                                            lista="EstadoCuenta"
                                        />
                                    </div>
                                    <div className="col-6 col-md-4 col-lg-2">
                                        <label htmlFor="cuenta_fechaAlta" className="form-label">Fecha alta</label>
                                        <DatePickerCustom
                                            name="cuenta_fechaAlta"
                                            placeholder=""
                                            className="form-control"
                                            value={state.entity.cuenta.fechaAlta}
                                            disabled={true}
                                        />
                                    </div>
                                    <div className="col-6 col-md-4 col-lg-2">
                                        <label htmlFor="cuenta_fechaBaja" className="form-label">Fecha baja</label>
                                        <DatePickerCustom
                                            name="cuenta_fechaBaja"
                                            placeholder=""
                                            className="form-control"
                                            value={state.entity.cuenta.fechaBaja}
                                            disabled={true}
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                    </Accordion>

                    {(state.mode !== OPERATION_MODE.NEW) && (
                        <>
                            <div className="m-top-20">
                                <Accordion title="Personas vinculadas">
                                    <VinculosVehiculoGrid
                                        processKey={state.processKey}
                                        disabled={state.mode === OPERATION_MODE.VIEW || !canEditPersonasVinculadas}
                                        data={{
                                            idVehiculo: state.id,
                                            list: state.entity.vinculosVehiculo
                                        }}
                                        onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                    />
                                </Accordion>
                            </div>
                            <div className="m-top-20">
                                <Accordion title="Domicilios">
                                    <DomiciliosGrid
                                        data={{
                                            list: domicilios
                                        }}
                                    />
                                </Accordion>
                            </div>
                            <div className="m-top-20">
                                <Accordion title="Datos del vehículo" open={datosOpen} onToggle={setDatosOpen}>
                                    <div className='row form-basic'>
                                        <div className="col-12 col-sm-4 col-lg-2">
                                            <FormLabel htmlFor="vehiculo_anioModelo" required>Año/Modelo</FormLabel>
                                            <input
                                                name="vehiculo_anioModelo"
                                                type="text"
                                                placeholder=""
                                                className={`form-control ${errorOf('anioModelo') ? 'is-invalid' : ''}`}
                                                value={vehiculo_formValues.anioModelo}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        vehiculo_formSet({
                                                            ...vehiculo_formValues,
                                                            anioModelo: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                pattern={PATTERNS.onlyNumbers}
                                                maxLength={4}
                                            />
                                            <FormError message={errorOf('anioModelo')} />
                                        </div>
                                        <div className="col-12 col-sm-4 col-lg-2">
                                            <FormLabel htmlFor="vehiculo_dominio" required>Dominio</FormLabel>
                                            <input
                                                name="vehiculo_dominio"
                                                type="text"
                                                placeholder=""
                                                className={`form-control ${errorOf('dominio') ? 'is-invalid' : ''}`}
                                                value={vehiculo_formValues.dominio}
                                                // onChange={({ target }) => {
                                                //     if (target.validity.valid && target.value.length <= 7) {
                                                //         vehiculo_formSet({ ...vehiculo_formValues, dominio: target.value.toUpperCase() });
                                                //         cuenta_formSet({ ...cuenta_formValues, numeroCuenta: target.value.toUpperCase() });
                                                //         setPendingChange(true);
                                                //     }
                                                // }}
                                                // disabled={state.mode === OPERATION_MODE.VIEW}
                                                disabled={true}
                                                autoComplete="off"
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                            <FormError message={errorOf('dominio')} />
                                        </div>
                                        {!state.showInfoVehiculoMenor &&
                                            <div className="col-12 col-sm-4 col-lg-2">
                                                <label htmlFor="vehiculo_dominioAnterior" className="form-label">Dominio
                                                    anterior</label>
                                                <input
                                                    name="vehiculo_dominioAnterior"
                                                    type="text"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={vehiculo_formValues.dominioAnterior}
                                                    onChange={vehiculo_formHandleProxy}
                                                    disabled={state.mode === OPERATION_MODE.VIEW}
                                                    autoComplete="off"
                                                />
                                                <FormError />
                                            </div>
                                        }

                                        <div className={`col-12 col-sm-12 ${state.showInfoVehiculoMenor ? 'col-lg-6' : 'col-lg-4'}`}>
                                            <FormLabel htmlFor="vehiculo_idIncisoVehiculo" required>Inciso</FormLabel>
                                            <InputEntidad
                                                name="vehiculo_idIncisoVehiculo"
                                                placeholder=""
                                                tipName={TIPS.NAME.MODALS.INCISO_VEHICULO_MODAL}
                                                className={`form-control ${errorOf('idIncisoVehiculo') ? 'is-invalid' : ''}`}
                                                value={vehiculo_formValues.idIncisoVehiculo}
                                                onChange={handleChangeInciso}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                title="Inciso vehículo"
                                                entidad="IncisoVehiculo"
                                            />
                                            <FormError message={errorOf('idIncisoVehiculo')} />
                                        </div>
                                        <div className="col-12 col-sm-6 col-lg-2">
                                            <FormLabel htmlFor="vehiculo_idTipoVehiculo" required>Tipo</FormLabel>
                                            <InputEntidad
                                                name="vehiculo_idTipoVehiculo"
                                                placeholder=""
                                                tipName={TIPS.NAME.MODALS.TIPO_VEHICULO_MODAL}
                                                className={`form-control ${errorOf('idTipoVehiculo') ? 'is-invalid' : ''}`}
                                                value={vehiculo_formValues.idTipoVehiculo}
                                                onChange={({target}) => {
                                                    vehiculo_formSet({
                                                        ...vehiculo_formValues,
                                                        idTipoVehiculo: target.value
                                                    });
                                                    setPendingChange(true);
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                title="Tipo vehículo"
                                                entidad="TipoVehiculo"
                                                filter={(row) => row.idIncisoVehiculo === vehiculo_formValues.idIncisoVehiculo}
                                            />
                                            <FormError message={errorOf('idTipoVehiculo')} />
                                        </div>
                                        <div className="col-12 col-sm-6 col-lg-2">
                                            <FormLabel htmlFor="vehiculo_idCategoriaVehiculo" required={state.mode === OPERATION_MODE.EDIT}>Categoría</FormLabel>
                                            <InputEntidad
                                                name="vehiculo_idCategoriaVehiculo"
                                                placeholder=""
                                                tipName={TIPS.NAME.MODALS.CATEGORIA_VEHICULO_MODAL}
                                                className={`form-control ${errorOf('idCategoriaVehiculo') ? 'is-invalid' : ''}`}
                                                value={vehiculo_formValues.idCategoriaVehiculo}
                                                onChange={({target}) => {
                                                    vehiculo_formSet({
                                                        ...vehiculo_formValues,
                                                        idCategoriaVehiculo: target.value
                                                    });
                                                    setPendingChange(true);
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                title="Categoría vehículo"
                                                entidad="CategoriaVehiculo"
                                                filter={(row) => row.idIncisoVehiculo === vehiculo_formValues.idIncisoVehiculo}
                                            />
                                            <FormError message={errorOf('idCategoriaVehiculo')} />
                                        </div>

                                        <div className="col-12 col-sm-6 col-lg-2">
                                            <FormLabel htmlFor="vehiculo_marca" required={state.mode === OPERATION_MODE.EDIT}>Marca</FormLabel>
                                            <input
                                                name="vehiculo_marca"
                                                type="text"
                                                placeholder=""
                                                className={`form-control ${errorOf('marca') ? 'is-invalid' : ''}`}
                                                value={vehiculo_formValues.marca}
                                                onChange={vehiculo_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                autoComplete="off"
                                            />
                                            <FormError message={errorOf('marca')} />
                                        </div>
                                        {!state.showInfoVehiculoMenor &&
                                            <div className="col-12 col-sm-6 col-lg-2">
                                                <label htmlFor="vehiculo_codigoMarca" className="form-label">Código de
                                                    marca</label>
                                                <input
                                                    name="vehiculo_codigoMarca"
                                                    type="text"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={vehiculo_formValues.codigoMarca}
                                                    onChange={({target}) => {
                                                        if (target.validity.valid) {
                                                            vehiculo_formSet({
                                                                ...vehiculo_formValues,
                                                                codigoMarca: target.value
                                                            });
                                                            setPendingChange(true);
                                                        }
                                                    }}
                                                    disabled={state.mode === OPERATION_MODE.VIEW}
                                                    autoComplete="off"
                                                    pattern={PATTERNS.onlyNumbersAndLetters}
                                                />
                                                <FormError />
                                            </div>
                                        }
                                        <div className={`col-12 col-md-6 ${state.showInfoVehiculoMenor ? 'col-lg-6' : 'col-lg-4'}`}>
                                            <FormLabel htmlFor="vehiculo_modelo" required={state.mode === OPERATION_MODE.EDIT}>Modelo</FormLabel>
                                            <input
                                                name="vehiculo_modelo"
                                                type="text"
                                                placeholder=""
                                                className={`form-control ${errorOf('modelo') ? 'is-invalid' : ''}`}
                                                value={vehiculo_formValues.modelo}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        vehiculo_formSet({
                                                            ...vehiculo_formValues,
                                                            modelo: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                autoComplete="off"
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                            <FormError message={errorOf('modelo')} />
                                        </div>
                                        <div className="col-12 col-md-6 col-lg-2">
                                            <label htmlFor="vehiculo_legajo" className="form-label">Clave
                                                N°/Legajo</label>
                                            <input
                                                name="vehiculo_legajo"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={vehiculo_formValues.legajo}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        vehiculo_formSet({
                                                            ...vehiculo_formValues,
                                                            legajo: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                autoComplete="off"
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                            <FormError />
                                        </div>
                                    </div>
                                    <div className='row form-basic'>
                                        <div className="col-12 col-sm-6 col-lg-2">
                                            <label htmlFor="vehiculo_numeroMotor" className="form-label">Número de
                                                motor</label>
                                            <input
                                                name="vehiculo_numeroMotor"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={vehiculo_formValues.numeroMotor}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        vehiculo_formSet({
                                                            ...vehiculo_formValues,
                                                            numeroMotor: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                autoComplete="off"
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                            <FormError />
                                        </div>
                                        <div className="col-12 col-sm-6 col-lg-2">
                                            <label htmlFor="vehiculo_marcaMotor" className="form-label">Marca del
                                                motor</label>
                                            <input
                                                name="vehiculo_marcaMotor"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={vehiculo_formValues.marcaMotor}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        vehiculo_formSet({
                                                            ...vehiculo_formValues,
                                                            marcaMotor: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                autoComplete="off"
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                            <FormError />
                                        </div>
                                        <div className="col-12 col-sm-6 col-lg-2">
                                            <label htmlFor="vehiculo_numeroChasis" className="form-label">N° de
                                                chasis/Bastidor</label>
                                            <input
                                                name="vehiculo_numeroChasis"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={vehiculo_formValues.numeroChasis}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        vehiculo_formSet({
                                                            ...vehiculo_formValues,
                                                            numeroChasis: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                autoComplete="off"
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                            <FormError />
                                        </div>
                                        <div className="col-12 col-sm-6 col-lg-2">
                                            <label htmlFor="vehiculo_serieMotor" className="form-label">Serie
                                                motor</label>
                                            <input
                                                name="vehiculo_serieMotor"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={vehiculo_formValues.serieMotor}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        vehiculo_formSet({
                                                            ...vehiculo_formValues,
                                                            serieMotor: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                autoComplete="off"
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                            <FormError />
                                        </div>
                                        <div className="col-12 col-sm-6 col-lg-2">
                                            <label htmlFor="vehiculo_valuacion" className="form-label">Valuación</label>
                                            <InputNumber
                                                name="vehiculo_valuacion"
                                                placeholder=""
                                                className="form-control"
                                                value={vehiculo_formValues.valuacion}
                                                precision={2}
                                                onChange={vehiculo_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                            />
                                            <FormError />
                                        </div>
                                        {!state.showInfoVehiculoMenor &&
                                            <>
                                                <div className="col-12 col-sm-6 col-lg-1">
                                                    <label htmlFor="vehiculo_peso" className="form-label">Peso</label>
                                                    <input
                                                        name="vehiculo_peso"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={vehiculo_formValues.peso}
                                                        onChange={({target}) => {
                                                            if (target.validity.valid) {
                                                                vehiculo_formSet({
                                                                    ...vehiculo_formValues,
                                                                    peso: target.value
                                                                });
                                                                setPendingChange(true);
                                                            }
                                                        }}
                                                        disabled={state.mode === OPERATION_MODE.VIEW}
                                                        autoComplete="off"
                                                        pattern={PATTERNS.onlyNumbersAndLetters}
                                                    />
                                                    <FormError />
                                                </div>
                                                <div className="col-12 col-sm-6 col-lg-1">
                                                    <label htmlFor="vehiculo_carga" className="form-label">Carga</label>
                                                    <input
                                                        name="vehiculo_carga"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={vehiculo_formValues.carga}
                                                        onChange={({target}) => {
                                                            if (target.validity.valid) {
                                                                vehiculo_formSet({
                                                                    ...vehiculo_formValues,
                                                                    carga: target.value
                                                                });
                                                                setPendingChange(true);
                                                            }
                                                        }}
                                                        disabled={state.mode === OPERATION_MODE.VIEW}
                                                        autoComplete="off"
                                                        pattern={PATTERNS.onlyNumbersAndLetters}
                                                    />
                                                    <FormError />
                                                </div>
                                            </>
                                        }
                                        {state.showInfoVehiculoMenor &&
                                            <div className="col-12 col-md-6 col-lg-2">
                                                <FormLabel htmlFor="vehiculo_cilindrada" required={state.mode === OPERATION_MODE.EDIT}>Cilindrada</FormLabel>
                                                <input
                                                    name="vehiculo_cilindrada"
                                                    type="text"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('cilindrada') ? 'is-invalid' : ''}`}
                                                    value={vehiculo_formValues.cilindrada}
                                                    onChange={vehiculo_formHandleProxy}
                                                    disabled={state.mode === OPERATION_MODE.VIEW}
                                                    autoComplete="off"
                                                />
                                                <FormError message={errorOf('cilindrada')} />
                                            </div>
                                        }
                                    </div>
                                    <div className='row form-basic'>
                                        <div className="col-12 col-sm-6 col-lg-2">
                                            <label htmlFor="vehiculo_idOrigenFabricacion"
                                                   className="form-label">Nacionalidad</label>
                                            <InputLista
                                                name="vehiculo_idOrigenFabricacion"
                                                placeholder=""
                                                className="form-control"
                                                value={vehiculo_formValues.idOrigenFabricacion}
                                                onChange={vehiculo_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                lista="OrigenFabricacion"
                                            />
                                            <FormError />
                                        </div>
                                        <div className="col-12 col-sm-6 col-lg-2">
                                            <label htmlFor="vehiculo_idCombustible"
                                                   className="form-label">Combustible</label>
                                            <InputLista
                                                name="vehiculo_idCombustible"
                                                placeholder=""
                                                className="form-control"
                                                value={vehiculo_formValues.idCombustible}
                                                onChange={vehiculo_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                lista="Combustible"
                                            />
                                            <FormError />
                                        </div>
                                        <div className="col-12 col-sm-6 col-lg-2">
                                            <FormLabel htmlFor="vehiculo_idUsoVehiculo" required={state.mode === OPERATION_MODE.EDIT}>Uso</FormLabel>
                                            <InputLista
                                                name="vehiculo_idUsoVehiculo"
                                                placeholder=""
                                                className={`form-control ${errorOf('idUsoVehiculo') ? 'is-invalid' : ''}`}
                                                value={vehiculo_formValues.idUsoVehiculo}
                                                onChange={vehiculo_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                lista="FinalidadVehiculo"
                                            />
                                            <FormError message={errorOf('idUsoVehiculo')} />
                                        </div>
                                        <div className="col-12 col-sm-6 col-lg-2">
                                            <label htmlFor="vehiculo_recupero" className="form-label">Recupero</label>
                                            <input
                                                name="vehiculo_recupero"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={vehiculo_formValues.recupero}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        vehiculo_formSet({
                                                            ...vehiculo_formValues,
                                                            recupero: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                autoComplete="off"
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                            <FormError />
                                        </div>
                                        <div className="col-12 col-sm-6 col-lg-2">
                                            <label htmlFor="vehiculo_codigoMTM" className="form-label">Código
                                                MTM</label>
                                            <input
                                                name="vehiculo_codigoMTM"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={vehiculo_formValues.codigoMTM}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        vehiculo_formSet({
                                                            ...vehiculo_formValues,
                                                            codigoMTM: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                autoComplete="off"
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                            <FormError />
                                        </div>
                                    </div>
                                </Accordion>
                            </div>
                            <div className="m-top-20">
                                <Accordion title="Datos administrativos" open={administrativosOpen} onToggle={setAdministrativosOpen}>
                                    <div className='row form-basic'>
                                        <div className="col-6 col-md-4 col-lg-3 col-xl-2">
                                            <label htmlFor="vehiculo_fechaAlta" className="form-label">Fecha
                                                alta/Trib.</label>
                                            <DatePickerCustom
                                                name="vehiculo_fechaAlta"
                                                placeholder=""
                                                className={`form-control ${errorOf('fechaAlta') ? 'is-invalid' : ''}`}
                                                value={vehiculo_formValues.fechaAlta}
                                                onChange={vehiculo_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                maxValue={today}
                                            />
                                            <FormError message={errorOf('fechaAlta')} />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-3 col-xl-2">
                                            <label htmlFor="vehiculo_fechaPatentamiento" className="form-label">Fecha de
                                                patentamiento</label>
                                            <DatePickerCustom
                                                name="vehiculo_fechaPatentamiento"
                                                placeholder=""
                                                className={`form-control ${errorOf('fechaPatentamiento') ? 'is-invalid' : ''}`}
                                                value={vehiculo_formValues.fechaPatentamiento}
                                                onChange={vehiculo_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                maxValue={today}
                                            />
                                            <FormError message={errorOf('fechaPatentamiento')} />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-3 col-xl-2">
                                            <label htmlFor="vehiculo_fechaRadicacion" className="form-label">Fecha de
                                                radicación</label>
                                            <DatePickerCustom
                                                name="vehiculo_fechaRadicacion"
                                                placeholder=""
                                                className={`form-control ${errorOf('fechaRadicacion') ? 'is-invalid' : ''}`}
                                                value={vehiculo_formValues.fechaRadicacion}
                                                onChange={vehiculo_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                maxValue={today}
                                            />
                                            <FormError message={errorOf('fechaRadicacion')} />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-3 col-xl-2">
                                            <label htmlFor="vehiculo_radicacionAnterior" className="form-label">Radicación
                                                anterior</label>
                                            <input
                                                name="vehiculo_radicacionAnterior"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={vehiculo_formValues.radicacionAnterior}
                                                onChange={vehiculo_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                autoComplete="off"
                                            />
                                            <FormError />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-3 col-xl-2">
                                            <label htmlFor="vehiculo_fechaTransferencia" className="form-label">Fecha de
                                                transferencia</label>
                                            <DatePickerCustom
                                                name="vehiculo_fechaTransferencia"
                                                placeholder=""
                                                className={`form-control ${errorOf('fechaTransferencia') ? 'is-invalid' : ''}`}
                                                value={vehiculo_formValues.fechaTransferencia}
                                                onChange={vehiculo_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                maxValue={today}
                                            />
                                            <FormError message={errorOf('fechaTransferencia')} />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-3 col-xl-2">
                                            <label htmlFor="vehiculo_fechaCompra" className="form-label">Fecha de
                                                compra</label>
                                            <DatePickerCustom
                                                name="vehiculo_fechaCompra"
                                                placeholder=""
                                                className={`form-control ${errorOf('fechaCompra') ? 'is-invalid' : ''}`}
                                                value={vehiculo_formValues.fechaCompra}
                                                onChange={vehiculo_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                maxValue={today}
                                            />
                                            <FormError message={errorOf('fechaCompra')} />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-3 col-xl-2">
                                            <label htmlFor="vehiculo_fechaHabilitacionDesde" className="form-label">Habilitación
                                                desde</label>
                                            <DatePickerCustom
                                                name="vehiculo_fechaHabilitacionDesde"
                                                placeholder=""
                                                className="form-control"
                                                value={vehiculo_formValues.fechaHabilitacionDesde}
                                                onChange={vehiculo_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                            />
                                            <FormError />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-3 col-xl-2">
                                            <label htmlFor="vehiculo_fechaHabilitacionHasta" className="form-label">Habilitación
                                                hasta</label>
                                            <DatePickerCustom
                                                name="vehiculo_fechaHabilitacionHasta"
                                                placeholder=""
                                                className={`form-control ${errorOf('fechaHabilitacionHasta') ? 'is-invalid' : ''}`}
                                                value={vehiculo_formValues.fechaHabilitacionHasta}
                                                onChange={vehiculo_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                minValue={vehiculo_formValues.fechaHabilitacionDesde}
                                            />
                                            <FormError message={errorOf('fechaHabilitacionHasta')} />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-3 col-xl-2">
                                            <label htmlFor="vehiculo_fechaDDJJ" className="form-label">Fecha UI
                                                DDJJ</label>
                                            <DatePickerCustom
                                                name="vehiculo_fechaDDJJ"
                                                placeholder=""
                                                className={`form-control ${errorOf('fechaDDJJ') ? 'is-invalid' : ''}`}
                                                value={vehiculo_formValues.fechaDDJJ}
                                                onChange={vehiculo_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                maxValue={today}
                                            />
                                            <FormError message={errorOf('fechaDDJJ')} />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-3 col-xl-2">
                                            <label htmlFor="vehiculo_fechaBaja" className="form-label">Fecha de
                                                baja</label>
                                            <DatePickerCustom
                                                name="vehiculo_fechaBaja"
                                                placeholder=""
                                                className={`form-control ${errorOf('fechaBaja') ? 'is-invalid' : ''}`}
                                                value={vehiculo_formValues.fechaBaja}
                                                onChange={vehiculo_formHandleProxy}
                                                disabled={true}
                                                minValue={vehiculo_formValues.fechaAlta}
                                            />
                                            <FormError message={errorOf('fechaBaja')} />
                                        </div>
                                        <div className="col-12 col-md-8 col-lg-6 col-xl-4">
                                            <label htmlFor="vehiculo_idMotivoBajaVehiculo" className="form-label">Motivo
                                                baja</label>
                                            <InputLista
                                                name="vehiculo_idMotivoBajaVehiculo"
                                                placeholder=""
                                                className="form-control"
                                                value={vehiculo_formValues.idMotivoBajaVehiculo}
                                                onChange={vehiculo_formHandleProxy}
                                                disabled={true}
                                                lista="MotivoBajaVehiculo"
                                            />
                                            <FormError />
                                        </div>
                                    </div>
                                </Accordion>
                            </div>
                            <div className="m-top-20">
                                <Accordion title="Estado" open={estadoOpen} onToggle={setEstadoOpen}>
                                    <div className='row form-basic'>
                                        <div className="col-6 col-md-3 col-lg-3 col-xl-2">
                                            <FormLabel htmlFor="vehiculo_idEstadoCarga" required>Estado de carga</FormLabel>
                                            <InputLista
                                                name="vehiculo_idEstadoCarga"
                                                placeholder=""
                                                className={`form-control ${errorOf('idEstadoCarga') ? 'is-invalid' : ''}`}
                                                value={vehiculo_formValues.idEstadoCarga}
                                                onChange={vehiculo_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW || state.entity.vehiculo.idEstadoCarga !== 20}
                                                lista="EstadoCarga"
                                            />
                                            <FormError message={errorOf('idEstadoCarga')} />
                                        </div>
                                        <div className="col-6 col-md-3 col-lg-3 col-xl-2">
                                            <label htmlFor="vehiculo_fechaCargaInicio" className="form-label">Fecha
                                                inicio carga</label>
                                            <DatePickerCustom
                                                name="vehiculo_fechaCargaInicio"
                                                placeholder=""
                                                className="form-control"
                                                value={state.entity.vehiculo.fechaCargaInicio}
                                                disabled={true}
                                            />
                                            <FormError />
                                        </div>
                                        <div className="col-6 col-md-3 col-lg-3 col-xl-2">
                                            <label htmlFor="vehiculo_fechaCargaFin" className="form-label">Fecha fin
                                                carga</label>
                                            <DatePickerCustom
                                                name="vehiculo_fechaCargaFin"
                                                placeholder=""
                                                className="form-control"
                                                value={state.entity.vehiculo.fechaCargaFin}
                                                disabled={true}
                                            />
                                            <FormError />
                                        </div>
                                        <div className="col-6 col-md-3 col-lg-3 col-xl-6">
                                            {state.mode === OPERATION_MODE.EDIT && state.entity.cuenta.idEstadoCuenta === CUENTA_STATE.ACTIVA &&
                                                <button className="btn action-button float-end m-top-30"
                                                        onClick={(event) => handleClickBaja()}>Baja</button>
                                            }
                                        </div>
                                    </div>
                                </Accordion>
                            </div>
                            <div className="m-top-20">
                                <Accordion title="Información adicional">
                                    <DataTaggerFormRedux
                                        title="Información adicional de vehículo"
                                        processKey={state.processKey}
                                        entidad="Vehiculo"
                                        idEntidad={state.id}
                                        disabled={(state.mode === OPERATION_MODE.VIEW)}
                                        onChange={(row) => setPendingChange(true)}
                                    />
                                </Accordion>
                            </div>

                            <TabsForm
                                state={state}
                                SetTabActive={SetTabActive}
                                UpdateEntity={UpdateEntity}
                                pendingChange={pendingChange}
                                refetchVehiculo={refetchVehiculo}
                            />

                        </>
                    )}

                </div>

            </section>
        </>
    )
}

export default SectionForm
